import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./home-theme.css";
import {
  Block,
  BlockContent,
  BlockDes,
  BlockHead,
  BlockTitle,
  Button,
  Icon,
  PreviewCard,
} from "../../components/Component";
import Logo from "../../images/logo.png";
import LogoDark from "../../images/logo-dark.png";
import { Form, FormGroup, Spinner, Alert } from "reactstrap";
import PageContainer from "../../layout/page-container/PageContainer";
import Head from "../../layout/head/Head";
import AuthFooter from "../auth/AuthFooter"
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";

//import Header from "../../layout/header/Header";
import Header from "../../Navbar/Navbar";
import Banner from "./components/banner/Banner";
import Hero from "./components/Hero/Hero";
import Carousell from "./components/carousel/Carousel";
import Plans from "./components/plans/Plans";
import Content from "./components/content/Content_1";
import Showcase from "./components/showcase/Showcase";
import Footer from "./components/footer/Footer";

const Home = () => {
  const [loading, setLoading] = useState(false);
  const [passState, setPassState] = useState(false);
  const [errorVal, setError] = useState("");

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-out-cubic",
      once: true,
      offset: 80,
    });
    AOS.refresh();
  }, []);

  const onFormSubmit = (formData) => {
    setLoading(true);
    const loginName = "cto-office@nosertechnology.com";
    const pass = "123456";
    if (formData.name === loginName && formData.passcode === pass) {
      localStorage.setItem("accessToken", "token");
      setTimeout(() => {
        window.history.pushState(
          `${process.env.PUBLIC_URL ? process.env.PUBLIC_URL : "/Homepage"}`,
          "auth-login",
          `${process.env.PUBLIC_URL ? process.env.PUBLIC_URL : "/Homepage"}`
        );
        window.location.reload();
      }, 2000);
    } else {
      setTimeout(() => {
        setError("Cannot login with credentials");
        setLoading(false);
      }, 2000);
    }
  };

  const { errors, register, handleSubmit } = useForm();

  return (
    <React.Fragment>
      <Header/>
      <Hero/>
      <Carousell/>
      <Content/>
      <Showcase/>
      {/* <Plans/> */}
      <Footer/>
      {/* 
      <Head title="Login" />
      <PageContainer>
        <Block className="nk-block-middle nk-auth-body  wide-xs">
          <div className="brand-logo pb-4 text-center">
            <Link to={process.env.PUBLIC_URL + "/"} className="logo-link">
              {/*
              <img className="logo-light logo-img logo-img-lg" src={Logo} alt="logo" />
              <img className="logo-dark logo-img logo-img-lg" src={LogoDark} alt="logo-dark" />
              
            </Link>
          </div>

          <PreviewCard className="card-bordered" bodyClass="card-inner-lg">
            
            <Form className="is-alter" onSubmit={handleSubmit(onFormSubmit)}>
              
              <FormGroup>
                
                
              </FormGroup>
              <FormGroup>
                <Button size="lg" className="btn-block" type="submit" color="primary">
                  {loading ? <Spinner size="sm" color="light" /> : "Sign in"}
                </Button>
              </FormGroup>
            </Form>
            <div className="form-note-s2 text-center pt-4">
              {" "}
              New on our platform? <Link to={`${process.env.PUBLIC_URL}/auth-register`}>Create an account</Link>
            </div>
            
          </PreviewCard>
        </Block>
        <AuthFooter />
      </PageContainer> */}
    </React.Fragment>
  );
};
export default Home;
